// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"99cab995","453":"ca41049c","455":"b00d3d34","977":"3f40f9ec"}[chunkId] + ".chunk.js";
};